var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500,850c12.9,0,23.3-10.4,23.3-23.3v-490c0-12.9-10.4-23.3-23.3-23.3c-12.9,0-23.3,10.4-23.3,23.3v490C476.7,839.5,487.1,850,500,850z M383.3,850c12.9,0,23.3-10.4,23.3-23.3l-23.3-490c0-12.9-10.4-23.3-23.3-23.3c-12.9,0-23.3,10.4-23.3,23.3l23.3,490C360,839.5,370.4,850,383.3,850z M920,173.3H710v-70c0-51.5-41.8-93.3-93.3-93.3H383.3c-51.5,0-93.3,41.8-93.3,93.3v70H80c-12.9,0-23.3,10.4-23.3,23.3c0,12.9,10.4,23.3,23.3,23.3h97.9l65.5,676.7c0,51.6,41.8,93.3,93.3,93.3h326.7c51.6,0,93.3-41.8,93.3-93.3L822.1,220H920c12.9,0,23.3-10.5,23.3-23.3C943.3,183.8,932.9,173.3,920,173.3z M336.7,103.3c0-25.8,20.9-46.7,46.7-46.7h233.3c25.8,0,46.7,20.9,46.7,46.7v70H336.7V103.3z M710,896.7c0,25.8-20.9,46.7-46.7,46.7H336.7c-25.8,0-46.7-20.9-46.7-46.7L224.5,220h551L710,896.7z M616.7,850c12.9,0,23.3-10.4,23.3-23.3l23.3-490c0-12.9-10.4-23.3-23.3-23.3c-12.9,0-23.3,10.4-23.3,23.3l-23.3,490C593.3,839.5,603.8,850,616.7,850z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoove);
export default __webpack_public_path__ + "static/media/remoove.51cf112081b9c703a6b6e6af88fe3a81.svg";
export { ForwardRef as ReactComponent };